import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Text, Button} from '@chakra-ui/react'
import {PremiumCrownIcon} from '../../components/icons'
import GlobalContentSlotHtml from '../content-slot/global-content-slot-html'

const PremiumBanner = ({premiumURL, onSocialLoginClick, customer, ssoEnable}) => {
    return (
        <Box
            bg="#ECE1C2"
            borderRadius="8px"
            padding="16px 24px"
            textAlign="center"
            mx="auto"
            mt={4}
            mb={{base: '6', md: '0'}}
            w="100%"
            sx={{
                '.premiumMembers-description-block': {
                    marginBottom: '10px'
                },
                '.premiumMembers-heading': {
                    fontSize: 'xl',
                    fontWeight: 'bold'
                }
            }}
        >
            <GlobalContentSlotHtml
                slotId={'premium_Members_Save_More_Get_Free_Shipping'}
                context={'global'}
                type={'html'}
            />

            {!['Fan', 'Mega Fan', 'Ultimate Fan'].includes(customer?.c_subscriptionLevel) && (
                <Button
                    bg="#000"
                    color="#fff"
                    borderRadius="33px"
                    px={6}
                    py={2.5}
                    fontSize="md"
                    fontWeight="bold"
                    mb={2}
                    _hover={{bg: '#333'}}
                    onClick={() => {
                        window.location.href = premiumURL
                    }}
                    leftIcon={<PremiumCrownIcon />}
                >
                    <FormattedMessage defaultMessage="Get Premium" id="pdp.get_premium" />
                </Button>
            )}

            {!customer?.isRegistered && (
                <Text fontSize={'xs'} color="black" lineHeight="5">
                    <FormattedMessage
                        id="promo.alreadyJoined"
                        defaultMessage="Already joined Crunchyroll Premium?"
                    />
                    <br />
                    <Button
                        variant={'link'}
                        href={ssoEnable ? '#' : '/login'}
                        color={'textColor'}
                        textDecoration="underline"
                        onClick={() => {
                            if (ssoEnable) onSocialLoginClick()
                        }}
                        textUnderlineOffset={'5px'}
                        fontSize={'xs'}
                        fontWeight={'extrabold'}
                        height={'auto'}
                        display={'inline'}
                        mx={'2px'}
                    >
                        <FormattedMessage id="promo.login" defaultMessage="Log in" />
                    </Button>
                    <FormattedMessage
                        id="promo.accessBenefits"
                        defaultMessage="to access your benefits."
                    />
                </Text>
            )}
        </Box>
    )
}

PremiumBanner.displayName = 'PremiumBanner'

PremiumBanner.propTypes = {
    premiumURL: PropTypes.string,
    onSocialLoginClick: PropTypes.func,
    customer: PropTypes.object,
    ssoEnable: PropTypes.bool
}

export default PremiumBanner
